import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e1304a8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("span", {
    class: ["num", {'red': parseInt(_ctx.score) < 60, 'orange': parseInt(_ctx.score) >= 60 && parseInt(_ctx.score) < 80, 'green': parseInt(_ctx.score) >= 80}]
  }, _toDisplayString(parseInt(_ctx.score)) + _toDisplayString(_ctx.addZero ? '.0' : ''), 3))
})